<script setup></script>

<template>
    <section class="bg-brand-900 py-28 md:py-36">
        <div class="mx-auto max-w-5xl px-6 lg:px-10">
            <figure>
                <blockquote>
                    <p
                        class="text-center text-3xl leading-tight font-extrabold tracking-tight text-white md:text-5xl lg:text-6xl"
                    >
                        &bdquo;Ať už jste na začátku, nebo míříte výš &ndash; jsme tu proto, abychom vám kryli
                        záda.&ldquo;
                    </p>
                </blockquote>

                <figcaption class="mt-10 flex flex-col items-center gap-1">
                    <p class="text-brand-100 text-sm font-semibold">Adam Žáček &middot; Ing. Kristýna Zavadilová</p>

                    <p class="text-brand-300 text-xs font-medium tracking-wider uppercase">
                        Zakladatelé SolveCount s.r.o.
                    </p>
                </figcaption>
            </figure>
        </div>
    </section>
</template>
